<script lang="ts">
  // https://www.fullstacklabs.co/blog/creating-an-svg-gauge-component-from-scratch
  import type { Snippet } from 'svelte';
  import { flipSwaps, type Direction } from '~/animations.svelte';
  import { fly } from 'svelte/transition';

  type Props = {
    swaps: number;
    direction?: Direction;
    radius: number;
    svg: Snippet;
    stars: Snippet;
    marquee?: string;
  };
  const props: Props = $props();
</script>

<div
  class="gauge-container"
  style="width: {2 * props.radius}px; margin-bottom: -{props.radius / 2}px"
>
  <svg
    height={props.radius * 2}
    width={props.radius * 2}
    viewBox="0 0 {props.radius * 2} {props.radius * 2}"
  >
    {@render props.svg()}
  </svg>
  <div class="swaps">
    {#key props.marquee ?? props.swaps}
      <div
        in:flipSwaps={{
          transition: 'in',
          duration: 150,
          direction: props.marquee ? 'left' : props.direction,
        }}
        out:flipSwaps={{
          transition: 'out',
          duration: 150,
          direction: props.marquee ? 'left' : props.direction,
        }}
        class="swap-count"
      >
        {#if props.marquee === undefined}
          {props.swaps}
        {:else}
          {props.marquee.split(' ')[0]}
        {/if}
      </div>
    {/key}
    {#key props.swaps === 1}
      {#if !props.marquee}
        <div
          class="swap-text"
          out:fly={{ y: 20 }}
          in:fly={{ y: 20, delay: 400 }}
        >
          {props.swaps === 1 ? 'swap' : 'swaps'}
        </div>
      {/if}
    {/key}
  </div>
  {@render props.stars()}
</div>

<style lang="scss">
  @use 'sass:color';
  @use 'sass:list';
  @use '~/theme/include-media' as *;

  .gauge-container {
    position: relative;
    margin: auto;
    text-align: center;
  }
  svg {
    overflow: visible;
  }
  .swaps {
    position: absolute;
    display: grid;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.5;
  }
  .swap-count,
  .swap-text {
    text-anchor: middle;
  }
  .swap-text {
    height: 0;
    grid-row: 2/3;
    grid-column: 1/2;
  }
  .swap-count {
    grid-row: 1/2;
    grid-column: 1/2;
    font-weight: bold;
    font-size: 3em;
    @include media('height<=tablet') {
      font-size: 2em;
    }
  }
</style>
